import { Box } from '@mui/system';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Navigator, { NAVIGATOR_HEIGHT } from '../Navigator';
import Copyright, { COPYRIGHT_HEIGHT } from '../Copyright';
import { ReactComponent as CaretLeft } from '../../assets/caret-left.svg';
import { ReactComponent as CaretRight } from '../../assets/caret-right.svg';
import { titleSx, contentSx } from './styles';

export default function PageLayout ({
  children,
  topRight,
  title,
  arrow = 'none',
  isAdmin = false,
  onTitleClick = () => {},
  report = false,
}: {
  children: React.ReactNode;
  topRight?: React.ReactNode;
  title?: string;
  arrow?: 'none' | 'left' | 'right';
  isAdmin?: boolean;
  onTitleClick?: () => void;
  report?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <main style={{ height: '100%' }}>
      <Navigator />
      <div
        style={{
          display: 'flex',
          height: `calc(100% - ${NAVIGATOR_HEIGHT + COPYRIGHT_HEIGHT}px - 200px)`,
        }}
      >
        <Box sx={contentSx}>
          <Box sx={titleSx}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className={'title ' + (report ? 'report' : '')} onClick={onTitleClick}>
                {t(title)}
              </span>
              {arrow === 'left' && <CaretLeft height={40} width={40} />}
              {arrow === 'right' && <CaretRight height={40} width={40} />}
              {isAdmin && (
                <Button className="admin-btn" variant="contained">
                  {t('Admin')}
                </Button>
              )}
            </div>

            {topRight}
          </Box>

          {children}
        </Box>
      </div>
      <Copyright />
    </main>
  );
}
